/**
 * AppLayout - HubSpot-style navigation layout
 * Global layout with collapsed left nav + top bar
 */

import React, { ReactNode } from 'react';
import CollapsedLeftNav from './navigation/CollapsedLeftNav';
import TopBar from './navigation/TopBar';

interface AppLayoutProps {
  children: ReactNode;
  pageTitle: string;
}

export default function AppLayout({ children, pageTitle }: AppLayoutProps) {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-gray-50">
      {/* Collapsed Left Navigation - 60px wide, always visible */}
      <CollapsedLeftNav />

      {/* Right Side: Top Bar + Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Navigation Bar - 60px height */}
        <TopBar pageTitle={pageTitle} />

        {/* Main Content Area - Scrollable */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
